export const ROLES = {
  VIEWER: "viewer",
  USER: "user",
  ADMIN: "admin",
  SUPER_ADMIN: "super_admin",
};

const ROLE_RANK = {
  viewer: 1,
  user: 2,
  admin: 3,
  super_admin: 4,
};

export const ROLE_OPTIONS = [
  { value: "viewer", label: "Viewer" },
  { value: "user", label: "User" },
  { value: "admin", label: "Admin" },
  { value: "super_admin", label: "Super Admin" },
];

export const canWrite = (role) => (ROLE_RANK[role] || 0) >= ROLE_RANK.user;
export const isAdminOrAbove = (role) =>
  (ROLE_RANK[role] || 0) >= ROLE_RANK.admin;
export const isSuperAdmin = (role) => role === ROLES.SUPER_ADMIN;
